/* eslint-disable react/no-array-index-key */
import { Row, Col } from 'react-bootstrap';
import { HeadingDesc, HeadingWithSpace, ListHeading } from '../Headings';
import { RightArrowWithBorder } from '../icons';
import { AnchorLink } from '../button';
import Status from '../status/Status';
import './articleItemLists.css';

function ArticleItemLists(props) {
  const {
    image,
    status = [],
    heading,
    btnText,
    link,
    desc,
    leftCol,
    rightCol,
    drName
  } = props;

  return (
    <div className="card articleItemLists">
      <Row>
        <Col md={leftCol}>
          <div className="card_img img_box">
            <img src={image} alt="img" />
          </div>
        </Col>
        <Col md={rightCol}>
          <div className="card_body">
            <div className="drName">
              <HeadingWithSpace text={drName} />
            </div>
            <div className="status_container">
              {status.map(({ statusProgress, statusText }, index) => (
                <Status
                  progress={statusProgress}
                  text={statusText}
                  key={`status-${index}`}
                />
              ))}
            </div>
            <ListHeading text={heading} />
            <HeadingDesc text={desc} />
            <div className="btn_container">
              <RightArrowWithBorder />
              <AnchorLink to={link} text={btnText} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ArticleItemLists;
